import React from 'react';
import { CreateInventoryFormPanel } from './FormLayout';
import FormFieldItem from './FormLayout';
import Input from '../Common/InputField';
import Select from '../Common/Select';
import { asset_status_options } from './utils';
import PropTypes from 'prop-types';
import LocationDropdown from './LocationDropdown';

const SprinklerHeads = ({
    locations,
    sprinklerHeads,
    setSprinklerHeads,
    manufacturers,
    location,
    setLocation,
    subLocation,
    setSubLocation,
    name,
    setName,
    assetStatus,
    setAssetStatus,
    maxSuctionPressure,
    setMaxSuctionPressure,
    driverManufacturer,
    setDriverManufacturer,
    pumpModelNumber,
    setPumpModelNumber,
    maxShutoffPressure,
    setMaxShutoffPressure,
    driverModelNumber,
    setDriverModelNumber,
    pumpSerialNumber,
    setPumpSerialNumber,
    ratedCapacity,
    setRatedCapacity,
    driverRatedRPM,
    setDriverRatedRPM,
    ratedRPM,
    setRatedRPM,
    ratedPressure,
    setRatedPressure,
    fuelTankCapacity,
    setFuelTankCapacity,
    controllerManufacturer,
    setControllerManufacturer,
    oneFiftyRatedCapacity,
    setOneFiftyRatedCapacity,
    controllerModelNumber,
    setControllerModelNumber,
    ratedPressureAtCapacity,
    setRatedPressureAtCapacity,
    controllerSerialNumber,
    setControllerSerialNumber,
}) => {

    const sprinkler_heads_subtype_options = [
        { value: "concealed", label: "Concealed" },
        { value: "pendant", label: "Pendant" },
        { value: "side_wall", label: "Side Wall" },
        { value: "upright", label: "Upright" }
    ];

    return (
        <CreateInventoryFormPanel enabled={false}>
            <LocationDropdown
                locations={locations}
                location={location}
                subLocation={subLocation}
                onChangeLocation={setLocation}
                onChangeSubLocation={setSubLocation}
               
            />
            <FormFieldItem>
                <Input
                    required
                    fullWidth
                    label="Name"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    error={!name}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    required
                    value={assetStatus}
                    label="Asset Status"
                   
                    options={asset_status_options}
                    onChange={e => setAssetStatus(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={sprinklerHeads}
                    label="Sprinkler Heads Subtype"
                   
                    options={sprinkler_heads_subtype_options}
                    onChange={e => setSprinklerHeads(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    type="number"
                    label="Maximum Suction Pressure"
                    value={maxSuctionPressure}
                    onChange={e => setMaxSuctionPressure(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={driverManufacturer}
                    label="Driver Manufacturer"
                   
                    options={manufacturers}
                    onChange={e => setDriverManufacturer(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="Pump Model Number"
                    value={pumpModelNumber}
                    onChange={e => setPumpModelNumber(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    type="number"
                    label="Maximum Shutoff Pressure (PSI)"
                    value={maxShutoffPressure}
                    onChange={e => setMaxShutoffPressure(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="Driver Model NUmber"
                    value={driverModelNumber}
                    onChange={e => setDriverModelNumber(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="Pump Serial Number"
                    value={pumpSerialNumber}
                    onChange={e => setPumpSerialNumber(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    type="number"
                    label="Rated Capacity (GPM)"
                    value={ratedCapacity}
                    onChange={e => setRatedCapacity(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    type="number"
                    label="Driver Rated RPM"
                    value={driverRatedRPM}
                    onChange={e => setDriverRatedRPM(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    type="number"
                    label="Rated RPM"
                    value={ratedRPM}
                    onChange={e => setRatedRPM(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    type="number"
                    label="Rated Pressure (PSI)"
                    value={ratedPressure}
                    onChange={e => setRatedPressure(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    type="number"
                    label="Fuel Tank Capacity (Gal)"
                    value={fuelTankCapacity}
                    onChange={e => setFuelTankCapacity(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={controllerManufacturer}
                    label="Controller Manufacturer"
                   
                    options={manufacturers}
                    onChange={e => setControllerManufacturer(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    type="number"
                    label="150% Rated Capacity (GPM)"
                    value={oneFiftyRatedCapacity}
                    onChange={e => setOneFiftyRatedCapacity(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="Controller Model Number"
                    value={controllerModelNumber}
                    onChange={e => setControllerModelNumber(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    type="number"
                    label="Rated Pressure @ Rated Capacity (PSI)"
                    value={ratedPressureAtCapacity}
                    onChange={e => setRatedPressureAtCapacity(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="Controller Serial Number"
                    value={controllerSerialNumber}
                    onChange={e => setControllerSerialNumber(e.target.value)}
                   
                />
            </FormFieldItem>
        </CreateInventoryFormPanel>
    );
};

SprinklerHeads.propTypes = {
    locations: PropTypes.array.isRequired,
    manufacturers: PropTypes.array.isRequired,
    location: PropTypes.string.isRequired,
    smokeAlarmSubtype: PropTypes.string.isRequired,
    setSmokeAlarmSubtype: PropTypes.func.isRequired,
    setLocation: PropTypes.func.isRequired,
    subLocation: PropTypes.string.isRequired,
    setSubLocation: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    setName: PropTypes.func.isRequired,
    assetStatus: PropTypes.string.isRequired,
    setAssetStatus: PropTypes.func.isRequired,
    maxSuctionPressure: PropTypes.string.isRequired,
    setMaxSuctionPressure: PropTypes.func.isRequired,
    driverManufacturer: PropTypes.string.isRequired,
    setDriverManufacturer: PropTypes.func.isRequired,
    pumpModelNumber: PropTypes.string.isRequired,
    setPumpModelNumber: PropTypes.func.isRequired,
    maxShutoffPressure: PropTypes.string.isRequired,
    setMaxShutoffPressure: PropTypes.func.isRequired,
    driverModelNumber: PropTypes.string.isRequired,
    setDriverModelNumber: PropTypes.func.isRequired,
    pumpSerialNumber: PropTypes.string.isRequired,
    setPumpSerialNumber: PropTypes.func.isRequired,
    ratedCapacity: PropTypes.string.isRequired,
    setRatedCapacity: PropTypes.func.isRequired,
    driverRatedRPM: PropTypes.string.isRequired,
    setDriverRatedRPM: PropTypes.func.isRequired,
    ratedRPM: PropTypes.string.isRequired,
    setRatedRPM: PropTypes.func.isRequired,
    ratedPressure: PropTypes.string.isRequired,
    setRatedPressure: PropTypes.func.isRequired,
    fuelTankCapacity: PropTypes.string.isRequired,
    setFuelTankCapacity: PropTypes.func.isRequired,
    controllerManufacturer: PropTypes.string.isRequired,
    setControllerManufacturer: PropTypes.func.isRequired,
    oneFiftyRatedCapacity: PropTypes.string.isRequired,
    setOneFiftyRatedCapacity: PropTypes.func.isRequired,
    controllerModelNumber: PropTypes.string.isRequired,
    setControllerModelNumber: PropTypes.func.isRequired,
    ratedPressureAtCapacity: PropTypes.string.isRequired,
    setRatedPressureAtCapacity: PropTypes.func.isRequired,
    controllerSerialNumber: PropTypes.string.isRequired,
    setControllerSerialNumber: PropTypes.func.isRequired,
    regulatedAssets: PropTypes.array.isRequired,
    regulatedAssetTypes: PropTypes.array.isRequired,
    setRegulatedAssets: PropTypes.func.isRequired
};

export default SprinklerHeads;
